// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataPromptDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingVocabularyDtoGenShape } from "./routing-vocabulary-dto.gen";
import { RoutingMetadataPromptVersionDtoGenShape } from "./routing-metadata-prompt-version-dto.gen";

export const RoutingMetadataPromptDtoGenShape = z.strictObject({
  schemaVersion: z.number(),
  outputSchema: z.string(),
  vocabulary: RoutingVocabularyDtoGenShape,
  versions: z.array(RoutingMetadataPromptVersionDtoGenShape),
});
